import { IAuthenticationService } from "./IAuthenticationService";
import AWSAuthenticationService from "./AWSAuthenticationService";
import { ISignupRequest } from "./ISignupRequest";

const appConfig = require("../app_config.json");

export interface IAuthenticationManager {
    login(email: string, password: string): Promise<string>;
    logout(): Promise<void>;
    signUp(request: ISignupRequest): Promise<void>;
    confirmRegistrationByCode(request: { email: string, code: string }): Promise<void>;
    resendConfirmationCode(email: string): Promise<void>;
    forgotPassword(email: string): Promise<void>;
    refreshSession(): Promise<string>;
}

class AuthenticationManager implements IAuthenticationManager {
    private authenticationService: IAuthenticationService;

    constructor(service: IAuthenticationService) {
        this.authenticationService = service;
    }

    async login(email: string, password: string): Promise<string> {
        return await this.authenticationService.login(email, password);
    }

    async logout(): Promise<void> {
        return await this.authenticationService.logout();
    }

    async signUp(request: ISignupRequest): Promise<void> {
        return await this.authenticationService.signUp(request);
    }

    async confirmRegistrationByCode(request: { email: string, code: string }): Promise<void> {
        return await this.authenticationService.confirmRegistrationByCode(request);
    }

    async resendConfirmationCode(email: string): Promise<void> {
        return await this.authenticationService.resendConfirmationCode(email);
    }

    async forgotPassword(email: string): Promise<void> {
        return await this.authenticationService.forgotPassword(email);
    }

    async confirmNewPassword(email: string, verificationCode: string, newPassword: string): Promise<void> {
        return await this.authenticationService.confirmNewPassword(email, verificationCode, newPassword);
    }

    async refreshSession(): Promise<string> {
        return await this.authenticationService.refreshSession();
    }
}

// Singleton
export default new AuthenticationManager(
    new AWSAuthenticationService(
        {
            userPoolId:  appConfig.userPoolId,
            appClientId: appConfig.appClientId
        }   
    )
);